(function (OC, OCA) {
    
    'use strict';

    var imageUrl = OCP.InitialState.loadState('ecit_10_users', 'orgImg');

    if (imageUrl) {
        $('.logo-icon').attr('style', 'background-image: url(' + imageUrl + ') !important; display: inline-flex !important;');
    }
    else{
        $('.logo-icon').attr('style', 'display: inline-flex !important;');
    }
    
})(OC, OCA);
